module.exports = __webpack_public_path__ + "img/dashboard-financeiro.d704ff8a.webp";